import { render, staticRenderFns } from "./PDFChatItem.vue?vue&type=template&id=4c2990fd&scoped=true&"
import script from "./PDFChatItem.vue?vue&type=script&lang=js&"
export * from "./PDFChatItem.vue?vue&type=script&lang=js&"
import style0 from "./PDFChatItem.vue?vue&type=style&index=0&id=4c2990fd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2990fd",
  null
  
)

export default component.exports